/* (c) Copyright Frontify Ltd., all rights reserved. */

export const ITALIC_PLUGIN = 'italic-plugin';
